import React from 'react';
import { Divider, Space, Tooltip } from 'antd';
import { DesktopOutlined, MailOutlined, MobileOutlined } from '@ant-design/icons';
import { COLORS } from '@guuru/theme-common';

interface ExpertNotificationsTagsProps {
  expert: {
    isEmailVerified: boolean;
    pushToken?: string;
    pushTokenWeb?: string;
  };
  showEmailVerified?: boolean;
}

const ExpertNotificationsTags = function ({
  expert,
  showEmailVerified = false,
}: ExpertNotificationsTagsProps) {
  return (
    <Space size={0} split={<Divider type="vertical" />}>
      {showEmailVerified && (
        <Tooltip title="Email Verified">
          <MailOutlined
            style={{
              color: expert.isEmailVerified ? COLORS.green : COLORS.red,
            }}
          />
        </Tooltip>
      )}
      <Tooltip title="Web Notifications">
        <DesktopOutlined
          style={{ color: expert?.pushTokenWeb ? COLORS.green : COLORS.red }}
        />
      </Tooltip>
      <Tooltip title="Mobile Notifications">
        <MobileOutlined
          style={{ color: expert?.pushToken ? COLORS.green : COLORS.red }}
        />
      </Tooltip>
    </Space>
  );
};

export default ExpertNotificationsTags;
